import React from 'react';

import './style.scss';

const Download = ({ title, link, date, fileType, fileSize }) => {

  return (
    <a href={link} target="_blank" className="Download" rel="noreferrer">
      <div className="Download__wrapper">
        <div className="icon icon-download icon-variant-0" />
        <div className="Download__text">
          <div className="Download__title">
            {title}
          </div>
          <div className="Download__extra">
            <div className="Download__details">
              ({`${fileType}`})
            </div>
          </div>
        </div>
      </div>
    </a>
  );
};

export default Download;
